module.exports = __webpack_public_path__ + "img/Abfahrk_status_erledigt.b44f342d.svg";